import { render } from "./TotalCountsRanking.vue?vue&type=template&id=66aff931"
import script from "./TotalCountsRanking.vue?vue&type=script&lang=js"
export * from "./TotalCountsRanking.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__